import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Admin from './admin/admin';
import Login from './login/login';

export default function Routes() {
	/*const history = useHistory();

	useEffect(() => {
		const x = sessionStorage.getItem('@amEnergiaPigz-path');
		console.log(x, 'aaa');
		if (x) {
			console.log(x, 'default');

			if (x.length > 0) {
				//history.push(x);
			}

			//
		}
	}, []);*/

	//sessionStorage.setItem('@amEnergiaPigz-path', '/admin');

	return (
		<BrowserRouter>
			<Switch>
				<Route path='/' exact component={Login} />
				<Route path='/admin' component={Admin} />
			</Switch>
		</BrowserRouter>
	);
}
